var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "India_Flag",
    "data-name": "India Flag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_101384",
    "data-name": "Path 101384",
    d: "M0,0H24V6H0Z",
    fill: "#f93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101385",
    "data-name": "Path 101385",
    d: "M0,160H24v6H0Z",
    transform: "translate(0 -154)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101386",
    "data-name": "Path 101386",
    d: "M0,320H24v6H0Z",
    transform: "translate(0 -308)",
    fill: "#128807"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37980",
    "data-name": "Group 37980",
    transform: "translate(7.795 3.901)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1737",
    "data-name": "Ellipse 1737",
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    transform: "translate(1.805 2.699)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1738",
    "data-name": "Ellipse 1738",
    cx: 2.1,
    cy: 2.1,
    r: 2.1,
    transform: "translate(2.105 2.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1739",
    "data-name": "Ellipse 1739",
    cx: 0.42,
    cy: 0.42,
    r: 0.42,
    transform: "translate(3.785 4.679)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0.387 3.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(1.988 1.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(1.217 0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1740",
    "data-name": "Ellipse 1740",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101387",
    "data-name": "Path 101387",
    d: "M-1.848,8.26-1.776,7l-.072-.6L-1.92,7Z",
    transform: "translate(1.92 -6.314)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37957",
    "data-name": "Group 37957",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1741",
    "data-name": "Ellipse 1741",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101388",
    "data-name": "Path 101388",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37959",
    "data-name": "Group 37959",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.234, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1742",
    "data-name": "Ellipse 1742",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101389",
    "data-name": "Path 101389",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37958",
    "data-name": "Group 37958",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1743",
    "data-name": "Ellipse 1743",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101390",
    "data-name": "Path 101390",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37963",
    "data-name": "Group 37963",
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 3.071, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(1.217 0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-3",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1744",
    "data-name": "Ellipse 1744",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101391",
    "data-name": "Path 101391",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37960",
    "data-name": "Group 37960",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1745",
    "data-name": "Ellipse 1745",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101392",
    "data-name": "Path 101392",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37962",
    "data-name": "Group 37962",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.234, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-4",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1746",
    "data-name": "Ellipse 1746",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101393",
    "data-name": "Path 101393",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37961",
    "data-name": "Group 37961",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1747",
    "data-name": "Ellipse 1747",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101394",
    "data-name": "Path 101394",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37971",
    "data-name": "Group 37971",
    transform: "matrix(-0.5, 0.866, -0.866, -0.5, 7.571, 2.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(1.988 1.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b",
    transform: "translate(1.217 0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-5",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1748",
    "data-name": "Ellipse 1748",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101395",
    "data-name": "Path 101395",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37964",
    "data-name": "Group 37964",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1749",
    "data-name": "Ellipse 1749",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101396",
    "data-name": "Path 101396",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37966",
    "data-name": "Group 37966",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.234, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-6",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1750",
    "data-name": "Ellipse 1750",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101397",
    "data-name": "Path 101397",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37965",
    "data-name": "Group 37965",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1751",
    "data-name": "Ellipse 1751",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101398",
    "data-name": "Path 101398",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37970",
    "data-name": "Group 37970",
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 3.071, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b",
    transform: "translate(1.217 0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-7",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1752",
    "data-name": "Ellipse 1752",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101399",
    "data-name": "Path 101399",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37967",
    "data-name": "Group 37967",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1753",
    "data-name": "Ellipse 1753",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101400",
    "data-name": "Path 101400",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37969",
    "data-name": "Group 37969",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.234, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-8",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1754",
    "data-name": "Ellipse 1754",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101401",
    "data-name": "Path 101401",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37968",
    "data-name": "Group 37968",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1755",
    "data-name": "Ellipse 1755",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101402",
    "data-name": "Path 101402",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37979",
    "data-name": "Group 37979",
    transform: "matrix(-0.5, -0.866, 0.866, -0.5, 4.658, 9.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c",
    transform: "translate(1.988 1.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b",
    transform: "translate(1.217 0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-9",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1756",
    "data-name": "Ellipse 1756",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101403",
    "data-name": "Path 101403",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37972",
    "data-name": "Group 37972",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1757",
    "data-name": "Ellipse 1757",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101404",
    "data-name": "Path 101404",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37974",
    "data-name": "Group 37974",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.234, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-10",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1758",
    "data-name": "Ellipse 1758",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101405",
    "data-name": "Path 101405",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37973",
    "data-name": "Group 37973",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1759",
    "data-name": "Ellipse 1759",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101406",
    "data-name": "Path 101406",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37978",
    "data-name": "Group 37978",
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 3.071, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b",
    transform: "translate(1.217 0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-11",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1760",
    "data-name": "Ellipse 1760",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101407",
    "data-name": "Path 101407",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37975",
    "data-name": "Group 37975",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1761",
    "data-name": "Ellipse 1761",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101408",
    "data-name": "Path 101408",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37977",
    "data-name": "Group 37977",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 1.234, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-12",
    "data-name": "a",
    transform: "translate(0.541 0.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1762",
    "data-name": "Ellipse 1762",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101409",
    "data-name": "Path 101409",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37976",
    "data-name": "Group 37976",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 0.504, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1763",
    "data-name": "Ellipse 1763",
    cx: 0.108,
    cy: 0.108,
    r: 0.108,
    transform: "matrix(0.991, 0.131, -0.131, 0.991, 2.061, 0)",
    fill: "#008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101410",
    "data-name": "Path 101410",
    d: "M.072,1.86.144.6.072,0,0,.6Z",
    transform: "translate(0 0.086)",
    fill: "#008"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.ed1fdb81ff07fd38e79aeda5d75e77a7.svg";
export { ForwardRef as ReactComponent };